import httpClient from "@/http-client";

export const get = (Options = {}) => {
    return httpClient
        .get("/api/phum-villages", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const store = data => {
    return httpClient
        .post("/api/phum-villages", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const update = (id, data) => {
    return httpClient
        .put(`/api/phum-villages/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const destroy = id => {
    return httpClient
        .delete(`/api/phum-villages/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const cityProvince = () => {
    return httpClient
        .get("/api/phum-villages/city-provinces")
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const khanDistrict = data => {
    return httpClient
        .get("/api/phum-villages/khan-districts", { params: data })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const sangkatCommune = data => {
    return httpClient
        .get("/api/phum-villages/sangkat-communes", { params: data })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export default {
    get,
    store,
    update,
    destroy,
    cityProvince,
    khanDistrict,
    sangkatCommune
};
